export default __webpack_public_path__ + "static/media/grafik_memory_hero_523x470_01.ad02ee1c.png";